import {IFrame, RowIndex} from '@mintdata/mint-kit/api/values/frames/Frame';
import {Frames} from '@mintdata/mint-kit/api/values/frames/Frames';
import {FieldRef} from '@mintdata/mint-kit/impl/frames/FieldRef';
import {RowFilterExpr} from '@mintdata/mint-kit/impl/frames/FrameSelectorTypes';
import {RowFilterKind} from '@mintdata/mint-kit/impl/frames/RowFilterKind';

export class FrameQueryResult
{
    public static readonly Empty:FrameQueryResult = new FrameQueryResult(false,
        false,
        Frames.empty(),
        [],
        RowFilterKind.All,
        -1,
        -1,
        null,
        null);

    constructor(public readonly didMatchRecords:boolean,
                public readonly hasRowFilter:boolean,
                public readonly frame:IFrame,
                public readonly selectedFieldRefs:FieldRef[],
                public readonly rowFilterKind:RowFilterKind,
                public readonly firstRowIndex:RowIndex,
                public readonly lastRowIndex:RowIndex,
                public readonly rowIndices:RowIndex[],
                public readonly rowFilterExpr:RowFilterExpr)
    {
    }

    withSelectedFields(newSelectedFieldRefs:FieldRef[]):FrameQueryResult
    {
        return new FrameQueryResult(
            this.didMatchRecords,
            this.hasRowFilter,
            this.frame,
            newSelectedFieldRefs,
            this.rowFilterKind,
            this.firstRowIndex,
            this.lastRowIndex,
            this.rowIndices,
            this.rowFilterExpr
        );
    }

    withAllRows():FrameQueryResult
    {
        return new FrameQueryResult(
            this.didMatchRecords,
            true,
            this.frame,
            this.selectedFieldRefs,
            RowFilterKind.All,
            this.firstRowIndex,
            this.lastRowIndex,
            this.rowIndices,
            this.rowFilterExpr
        );
    }

    withFirstRowOnly():FrameQueryResult
    {
        return new FrameQueryResult(
            this.didMatchRecords,
            true,
            this.frame,
            this.selectedFieldRefs,
            RowFilterKind.First,
            this.firstRowIndex,
            this.lastRowIndex,
            this.rowIndices,
            this.rowFilterExpr
        );
    }

    withLastRowOnly():FrameQueryResult
    {
        return new FrameQueryResult(
            this.didMatchRecords,
            true,
            this.frame,
            this.selectedFieldRefs,
            RowFilterKind.Last,
            this.firstRowIndex,
            this.lastRowIndex,
            this.rowIndices,
            this.rowFilterExpr
        );
    }

    withSelectedIndex(newSelectedIndex:RowIndex):FrameQueryResult
    {
        return new FrameQueryResult(
            this.didMatchRecords,
            true,
            this.frame,
            this.selectedFieldRefs,
            RowFilterKind.ByIndex,
            newSelectedIndex,
            this.lastRowIndex,
            this.rowIndices,
            this.rowFilterExpr
        );
    }

    withIndexRange(firstIndex:RowIndex, lastIndex:RowIndex):FrameQueryResult
    {
        return new FrameQueryResult(
            this.didMatchRecords,
            true,
            this.frame,
            this.selectedFieldRefs,
            RowFilterKind.ByRange,
            firstIndex,
            lastIndex,
            this.rowIndices,
            this.rowFilterExpr
        );
    }

    withRowFilterExpr(newRowFilterExpr:RowFilterExpr):FrameQueryResult
    {
        return new FrameQueryResult(
            this.didMatchRecords,
            true,
            this.frame,
            this.selectedFieldRefs,
            RowFilterKind.ByFilter,
            this.firstRowIndex,
            this.lastRowIndex,
            this.rowIndices,
            newRowFilterExpr
        );
    }
}
